/**
 * @generated SignedSource<<05acb9d6002e3b077bf67626fb5d2de4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectPickerProject$data = {
  readonly __typename: "ProjectV2";
  readonly closed: boolean;
  readonly id: string;
  readonly number: number;
  readonly title: string;
  readonly viewerCanUpdate: boolean;
  readonly " $fragmentType": "ProjectPickerProject";
};
export type ProjectPickerProject$key = {
  readonly " $data"?: ProjectPickerProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPickerProject">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ProjectPickerProject"
};

(node as any).hash = "ddac06ed21392b4310227bd5992b964c";

export default node;
